define('views/details',["require", "exports", "jquery", "backbone", "common", "rivets", "models/book-state", "fotorama"], function (_require, _exports, _jquery, _backbone, _common, _rivets, _bookState, _fotorama) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _jquery = _interopRequireDefault(_jquery);
  _rivets = _interopRequireDefault(_rivets);
  _bookState = _interopRequireDefault(_bookState);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  var cache;
  function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
  function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a, u = !0; return { s: function s() { t = t.call(r); }, n: function n() { u = !0; var r = t.next(); return r.done ? { done: !0 } : { value: r.value, done: u = !1 }; }, e: function e(r) { o = !0, a = r; }, f: function f() { try { u || null == t.return || t.return(); } finally { if (o) throw a; } } }; }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  var FOTORAMA_OPTIONS = {
    width: '100%',
    fit: 'cover',
    ratio: 3 / 2,
    nav: false,
    loop: false,
    click: true,
    swipe: true,
    trackpad: true,
    transition: 'dissolve'
  };
  var _default = _exports.default = _backbone.View.extend({
    initialize() {
      this.article = this.el.querySelector('article[data-id]');
      this.cover = this.el.querySelector('.rental-cover');
      this.coverGallery = this.cover.querySelector('.rental-gallery');
      this.coverFotorama = this.cover.querySelector('.rental-gallery__fotorama');
      this.modelID = this.article.dataset.id;
      this.state = new _bookState.default();
      this.state.parseQuery();
      this._initCover();
      this._initLocation();
      this.binding = _rivets.default.bind(this.article, {
        f: this.state
      });
    },
    _initCover() {
      var imgSrc = this.coverFotorama.querySelector('img').src;
      if (imgSrc.indexOf('-1280w.') > 0) {
        var retina = window.devicePixelRatio > 1;
        var width = screen.width;
        var suffix;
        if (width >= 1920) {
          suffix = '2048w';
        } else if (width >= 1600) {
          suffix = retina ? '2048w' : '1680w';
        } else if (width >= 1440) {
          suffix = retina ? '2048w' : '1536w';
        } else if (width >= 1366) {
          suffix = retina ? '2048w' : '1440w';
        } else if (width >= 1280) {
          suffix = retina ? '1680w' : '1366w';
        } else {
          suffix = retina ? '1680w' : '1280w';
        }
        var _iterator = _createForOfIteratorHelper(this.coverFotorama.querySelectorAll('img')),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var img = _step.value;
            img.src = img.src.replace('-1280w', `-${suffix}`);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      var options = _objectSpread(_objectSpread({}, FOTORAMA_OPTIONS), this._buildCoverOptions());
      if ((0, _common.isMobile)()) {
        options.transition = 'slide';
      }
      this._polyCover();
      var firstImage = false;
      this.fotorama = (0, _jquery.default)(this.coverFotorama).fotorama(options).data('fotorama');
      this.coverFotorama.addEventListener('fotorama:load', () => {
        if (firstImage) {
          return;
        }
        firstImage = true;
        setTimeout(() => this.coverGallery.removeAttribute('style'), 1000);
      });
      this.coverFotorama.addEventListener('fotorama:show', () => {
        this.cover.classList.toggle('rental-cover--frame', this.fotorama.activeIndex !== 0);
      });
      addEventListener('resize', this._windowResize = this._resizeCover.bind(this), {
        passive: true
      });
    },
    _finiCover() {
      this.fotorama.destroy();
      removeEventListener('resize', this._windowResize);
    },
    _resizeCover() {
      if ((0, _common.isAddressBarToggled)(innerHeight)) {
        return;
      }
      this._updateCover();
    },
    _updateCover() {
      this.fotorama.setOptions(this._buildCoverOptions());
      this._polyCover();
    },
    _polyCover() {
      if (Modernizr.cssvhunit && !this._isOldSafari()) {
        return;
      }
      var ratio = innerWidth / innerHeight;
      if (ratio < 1) {
        this.cover.style.height = 'auto';
      } else {
        this.cover.height = innerHeight;
      }
    },
    _isOldSafari() {
      var isSafari6 = !!navigator.userAgent.match(/safari/i) && !navigator.userAgent.match(/chrome/i) && typeof document.body.style.webkitFilter !== 'undefined';
      return isSafari6;
    },
    _buildCoverOptions() {
      var ratio = innerWidth / innerHeight;
      return {
        height: ratio < 1 ? false : '100%',
        ratio: ratio < 1 ? 1.5 : false
      };
    },
    async _initLocation() {
      try {
        var locationEl = document.querySelector('.rental-location');
        var _await$import = await new Promise((_resolve, _reject) => _require(['@googlemaps/js-api-loader'], imported => _resolve(_interopRequireWildcard(imported)), _reject)),
          setOptions = _await$import.setOptions,
          importLibrary = _await$import.importLibrary;
        setOptions({
          key: locationEl.dataset.googleMapsKey,
          v: 'weekly',
          libraries: ['places'],
          language: document.documentElement.lang,
          region: 'FR'
        });
        var _await$importLibrary = await importLibrary('maps'),
          Circle = _await$importLibrary.Circle;
        await customElements.whenDefined('gmp-map');
        var mapEl = locationEl.querySelector('gmp-map');
        this.locationMarker = new Circle({
          center: mapEl.innerMap.getCenter(),
          radius: 96,
          map: mapEl.innerMap,
          strokeColor: '#e71600',
          strokeOpacity: 0.6,
          strokeWeight: 1.2,
          fillColor: '#e71600',
          fillOpacity: 0.32
        });
      } catch (_unused) {}
    },
    _finiLocation() {},
    close() {
      this.binding.unbind();
      this._finiCover();
      this._finiLocation();
    },
    currency(currency) {
      this.state.set({
        currency
      });
    }
  });
});//# sourceMappingURL=details.js.map
;
